import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TransactionStatusQueryParams } from '../../models/transaction-status-query-params';

@Component({
  selector: 'app-transaction-status',
  templateUrl: './transaction-status.component.html',
  styleUrls: ['./transaction-status.component.scss']
})
export class TransactionStatusComponent implements OnInit {

  queryParams: TransactionStatusQueryParams;

  constructor(
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.getQueryParams();
  }


  private getQueryParams(): void {
    this.route.queryParamMap
      .subscribe(queryParams => {
        this.queryParams = new TransactionStatusQueryParams(
          queryParams.get('status'),
          queryParams.get('refid'),
          queryParams.get('amount'),
          queryParams.get('cardno')
        );
      });
  }

}
